import Web3 from "web3";

export const TestMode = true;

export const MainChainId = 1;
export const TestChainId = 1337;
export const TestChainId2 = 1337;
export const ChainId = TestMode ? TestChainId2 : MainChainId;

// @ts-ignore
export const ethereum = window["ethereum"] || undefined;
export const web3 = new Web3(ethereum);

export type Chain = {
	chainId: string,
	chainName: string,
	rpcUrls: string[],
	blockExplorerUrls: string[],
	nativeCurrency: {
		name: string,
		symbol: string,
		decimals: number
	}
}

export const TestChainDetail: Chain = {
	chainId: web3.utils.toHex(TestChainId),
	chainName: '8848Testnet',
	rpcUrls: ['http://80.209.229.233:8848/'],
	blockExplorerUrls:[''],
	nativeCurrency: {
		name: 'ETH',
		symbol: 'ETH',
		decimals: 18,
	}
}
export const TestChainDetail2: Chain = {
	chainId: web3.utils.toHex(TestChainId2),
	chainName: 'LocalTestnet',
	rpcUrls: ['http://127.0.0.1:7545/'],
	blockExplorerUrls:[''],
	nativeCurrency: {
		name: 'ETH',
		symbol: 'ETH',
		decimals: 18,
	}
}
export const MainChainDetail =  {
	chainId: web3.utils.toHex(MainChainId),
	chainName: 'Ethereum',
	rpcUrls: ['https://mainnet.infura.io/v3/'],
	blockExplorerUrls: ['https://etherscan.io'],
	nativeCurrency: {
		name: 'ETH',
		symbol: 'ETH',
		decimals: 18,
	}
}
export const ChainDetail = TestMode ? TestChainDetail2 : MainChainDetail

